const { sanitiseBatchNo } = require('../../../batch/tools')
const { SHIPSY_SOURCE, STOCK_TRANSACTION_TYPES } = require('../../constants')

// Sales-return payload (may arrive wrapped in a one-item array):
//   [{ sales_return_reference, request_id, grn_date, items: [
//        { sku_code, batch_number, accepted_quantity, put_zone, reason }
//      ] }]
async function extract (rawPayload, { mainApi }) {
  const payload = Array.isArray(rawPayload) ? rawPayload[0] : rawPayload
  const items = payload && payload.items
  if (!Array.isArray(items) || items.length === 0) return []
  if (!payload.sales_return_reference) return []

  let originalShipment
  try {
    originalShipment = await mainApi.shipment.getShipmentByNumber({
      shipmentNumber: payload.sales_return_reference
    })
  } catch (err) {
    return []
  }
  if (!originalShipment) return []

  const requestId = String(payload.request_id)
  const rows = []

  for (const item of items) {
    const quantity = Number(item.accepted_quantity)
    if (quantity <= 0) continue

    rows.push({
      source: SHIPSY_SOURCE,
      type: STOCK_TRANSACTION_TYPES.SALES_RETURN,
      request_id: requestId,
      origin: originalShipment.destination.id,
      origin_zone: null,
      destination: originalShipment.origin.id,
      destination_zone: item.put_zone || null,
      sku: String(item.sku_code),
      batch: sanitiseBatchNo(item.batch_number || 'UNKNOWN'),
      quantity,
      reason: item.reason,
      payload: item,
      created_at: payload.grn_date,
      updated_at: payload.grn_date
    })
  }

  return rows
}

module.exports = extract
